import { render, staticRenderFns } from "./index.vue?vue&type=template&id=474b47ea&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474b47ea')) {
      api.createRecord('474b47ea', component.options)
    } else {
      api.reload('474b47ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=474b47ea&", function () {
      api.rerender('474b47ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/plugins/js-cookie/index.vue"
export default component.exports